import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
import { axiosSalary } from "../api/axiosInstance";

const AddEditShiftMaster = ({ editingData, onClose, onSuccess }) => {
    let storedUser = {};
    try {
        storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    } catch { }
    const groupId = storedUser?.groupId || 0;
    const userId = storedUser?.userId || 0;
    const defaultRestId = storedUser?.restaurantId || 0;

    const [menuOpen, setMenuOpen] = useState(true);
    /* ================= SHIFT OPTIONS ================= */
    const shiftOptions = [
        { label: "Open", value: 1 },
        { label: "Reporting", value: 2 },
        { label: "Closing", value: 3 },
    ];

    /* ================= STATE ================= */
    const [form, setForm] = useState({
        shiftName: "Open",
        shiftType: 1,
        reportingTime: null,
        closingTime: null,
        lateGraceMinutes: 0,
        earlyLeaveGraceMinutes: 0,
        // isActive: true,
    });

    const [selectedShift, setSelectedShift] = useState(shiftOptions[0]);
    const [saving, setSaving] = useState(false);

    /* ================= REFS ================= */
    const shiftSelectRef = useRef(null);
    const reportingRef = useRef(null);
    const closingRef = useRef(null);
    const lateGraceRef = useRef(null);
    const earlyGraceRef = useRef(null);
    const saveRef = useRef(null);

    /* ================= LOAD EDIT DATA ================= */
    useEffect(() => {
        if (editingData) {
            const selected = shiftOptions.find(
                (s) => s.value === editingData.shiftType
            ) || shiftOptions[0];

            setForm({
                shiftName: editingData.shiftName || selected.label,
                shiftType: editingData.shiftType || selected.value,
                reportingTime: editingData.reportingTime || null,
                closingTime: editingData.closingTime || null,
                lateGraceMinutes: editingData.lateGraceMinutes || 0,
                earlyLeaveGraceMinutes: editingData.earlyLeaveGraceMinutes || 0,
                // isActive: editingData.isActive ?? true,
            });
            setSelectedShift(selected);
        }

        // focus shift select on open
        setTimeout(() => shiftSelectRef.current?.focus(), 100);
    }, [editingData]);

    /* ================= HANDLE CHANGE ================= */
    const handleChange = (field, value) =>
        setForm((prev) => ({ ...prev, [field]: value }));

    /* ================= HANDLE SHIFT SELECT ================= */
    const handleShiftSelect = (option) => {
        setSelectedShift(option);
        handleChange("shiftName", option.label);
        handleChange("shiftType", option.value);
        setTimeout(() => reportingRef.current?.focus(), 50); // move focus next
    };

    /* ================= KEYBOARD NAVIGATION ================= */
    const handleKey = (e, nextRef, prevRef) => {
        if (e.key === "Enter") {
            e.preventDefault();
            nextRef?.current?.focus();
        }
        if (e.key === "Escape") {
            e.preventDefault();
            prevRef?.current ? prevRef.current.focus() : onClose?.();
        }
    };

    /* ================= SAVE ================= */
    const handleSave = async () => {
        if (!form.shiftName) return alert("Select Shift Name");
        
        try {
            setSaving(true);

            // Ensure HH:mm:ss format
            const formatTime = (time) => {
    if (!time || time.trim() === "") return null;

    return time.length === 5 ? `${time}:00` : time;
};

const reportingTime = formatTime(form.reportingTime);
const closingTime = formatTime(form.closingTime);

            const payload = {
                groupId,
                // restId: defaultRestId,
                shiftId: editingData?.shiftId || 0,
                shiftName: form.shiftName,
                shiftType: form.shiftType,
                reportingTime,
                closingTime,
                lateGraceMinutes: Number(form.lateGraceMinutes),
                earlyLeaveGraceMinutes: Number(form.earlyLeaveGraceMinutes),
                // isActive: form.isActive,
                userId,
                id: editingData?.id,
            };

            await axiosSalary.post("/AttendanceShift/UpsertShift", payload);
            onSuccess?.();
            onClose?.();
        } catch (err) {
            console.error("Save shift error:", err);
            alert("Failed to save shift");
        } finally {
            setSaving(false);
        }
    };

    return (
         <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-3">
      <div className="bg-white w-full max-w-sm rounded-xl shadow-xl max-h-[90vh] overflow-auto">
        {/* HEADER */}
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="font-bold text-lg">
            {editingData ? "Edit Shift" : "Add Shift"}
          </h2>
          <button onClick={onClose} className="text-red-500 text-xl font-bold">
            ✕
          </button>
        </div>

        {/* BODY */}
        <div className="p-3 grid grid-cols-1 gap-3">
          {/* SHIFT SELECT */}
          <div>
            <label className="text-sm font-medium">Shift Name *</label>
            <Select
              ref={shiftSelectRef}
              options={shiftOptions}
              value={selectedShift}
              onChange={(option) => {
                setSelectedShift(option);
                handleChange("shiftName", option.label);
                handleChange("shiftType", option.value);
                setMenuOpen(false);
                setTimeout(() => reportingRef.current?.focus(), 50);
              }}
              menuIsOpen={menuOpen}
              onMenuOpen={() => setMenuOpen(true)}
              onMenuClose={() => setMenuOpen(false)}
              onFocus={() => setMenuOpen(true)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  const highlightedOption = shiftSelectRef.current?.state?.focusedOption;
                  if (highlightedOption) {
                    setSelectedShift(highlightedOption);
                    handleChange("shiftName", highlightedOption.label);
                    handleChange("shiftType", highlightedOption.value);
                    setMenuOpen(false);
                    setTimeout(() => reportingRef.current?.focus(), 50);
                  }
                }
                if (e.key === "Escape") {
                  e.preventDefault();
                  setMenuOpen(false);
                  onClose?.();
                }
              }}
              placeholder="Select Shift"
            />
          </div>

          {/* REPORTING TIME */}
          <div>
            <label className="text-sm font-medium">Reporting Time *</label>
            <input
              ref={reportingRef}
              type="time"
              value={form.reportingTime}
              onChange={(e) => handleChange("reportingTime", e.target.value)}
              onKeyDown={(e) => handleKey(e, closingRef, shiftSelectRef)}
              className="w-full border rounded-lg px-2 py-1 mt-1"
            />
          </div>

          {/* CLOSING TIME */}
          <div>
            <label className="text-sm font-medium">Closing Time *</label>
            <input
              ref={closingRef}
              type="time"
              value={form.closingTime}
              onChange={(e) => handleChange("closingTime", e.target.value)}
              onKeyDown={(e) => handleKey(e, lateGraceRef, reportingRef)}
              className="w-full border rounded-lg px-2 py-1 mt-1"
            />
          </div>

          {/* LATE GRACE */}
          <div>
            <label className="text-sm font-medium">Late Grace Minutes</label>
            <input
              ref={lateGraceRef}
              type="number"
              value={form.lateGraceMinutes}
              onChange={(e) => handleChange("lateGraceMinutes", e.target.value)}
              onKeyDown={(e) => handleKey(e, earlyGraceRef, closingRef)}
              className="w-full border rounded-lg px-2 py-1 mt-1"
            />
          </div>

          {/* EARLY LEAVE GRACE */}
          <div>
            <label className="text-sm font-medium">Early Leave Grace Minutes</label>
            <input
              ref={earlyGraceRef}
              type="number"
              value={form.earlyLeaveGraceMinutes}
              onChange={(e) =>
                handleChange("earlyLeaveGraceMinutes", e.target.value)
              }
              onKeyDown={(e) => handleKey(e, saveRef, lateGraceRef)}
              className="w-full border rounded-lg px-2 py-1 mt-1"
            />
          </div>

          {/* STATUS */}
          {/* <div className="flex items-center gap-2 mt-2">
            <input
              type="checkbox"
              checked={form.isActive}
              onChange={(e) => handleChange("isActive", e.target.checked)}
              id="activeCheck"
            />
            <label htmlFor="activeCheck" className="text-sm">
              Active
            </label>
          </div> */}
        </div>

        {/* FOOTER */}
        <div className="flex justify-end gap-2 p-4 border-t">
          <button onClick={onClose} className="px-4 py-2 rounded-lg border">
            Cancel
          </button>
          <button
            ref={saveRef}
            onClick={handleSave}
            disabled={saving}
            className="px-4 py-2 rounded-lg bg-purple-600 text-white hover:bg-purple-700 disabled:opacity-60"
          >
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
    );
};

export default AddEditShiftMaster;